import React from 'react'
import ReactDOMServer from 'react-dom/server'
import i18next from 'i18next'
import { connect } from 'react-redux'
import hash from 'object-hash'
import { MapContainer, TileLayer, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.markercluster'
import L from 'leaflet'

import { getConstants } from 'src/lib/constants'
import { getAllDealers, getRegionsProvinces } from 'src/store/dealers'
import { getAllCategories } from 'src/store/category'
import { getAllUsers } from 'src/store/users'
import { getAllBrands } from 'src/store/brand'
import FilterGroup from 'src/components/system_wide/filter_group'
import CheckboxFilter from 'src/components/system_wide/checkbox_filter'
import SelectAgentsModal from 'src/components/system_wide/select_agents_modal'
import { Button, Spinner, Modal } from 'react-bootstrap'
import { Trans } from 'react-i18next'
import RadiolistFilter from '../system_wide/radiolist_filter'
import { getDealerBrandStatus } from '../dealers/helper'
import DealerForm from '../dealers/dealer_form'
import { startOfToday } from 'date-fns'

const { t } = i18next

const mstp = state => {
  let { regions_provinces, all_dealers } = state.dealers
  let { all_categories: categories } = state.categories
  let { id, business_role_priority } = state.userInfo
  let { all_brands: brands } = state.brands
  let { all_users: users } = state.users

  let dealers = all_dealers.filter(dealer => {
    return dealer.lat !== null
  })

  return {
    business_role_priority,
    user_id: id,
    dealers,
    users,
    brands,
    categories,
    regions_provinces,
  }
}

const icons = {
  danger: L.divIcon({
    className: 'custom-marker custom-danger', // Aggiungi la classe per il marker "danger"
    iconSize: [30, 30], // Dimensione dell'icona
    iconAnchor: [15, 30], // Punto di ancoraggio dell'icona
  }),
  warning: L.divIcon({
    className: 'custom-marker custom-warning', // Aggiungi la classe per il marker "warning"
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  }),
  success: L.divIcon({
    className: 'custom-marker custom-success', // Aggiungi la classe per il marker "success"
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  }),
}

class InteractiveMapDealers extends React.Component {
  state = {
    ready: false,
    status_filter: 'all',
    filtered_brands: [],
    filtered_users: [],
    filtered_regions: [],
    filtered_provinces: [],
    loading: false,

    filters_hash: '',
    current_dealer: null,
    show: false,
  }

  initialFiltersHash = ''
  selectAgentsModalRef = React.createRef()
  dealer_statuses = []

  constructor(props) {
    super(props)
    let { dealer_statuses } = getConstants()
    Object.keys(dealer_statuses).forEach(key => {
      this.dealer_statuses.push({ id: key, name: dealer_statuses[key] })
    })
  }

  async componentDidMount() {
    await this.props.dispatch(getAllCategories())
    await this.props.dispatch(getAllBrands())
    await this.props.dispatch(getAllUsers({ filtered_roles_priority: [4] }))
    await this.props.dispatch(getRegionsProvinces())
    this.setState(
      {
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_users: this.props.users.map(u => u.id),
      },
      async () => {
        await this.props.dispatch(
          getRegionsProvinces({
            filtered_brands: this.state.filtered_brands,
            filtered_users: this.state.filtered_users,
            status_filter: this.state.status_filter,
          })
        )
        this.setState(
          {
            filtered_regions: Object.keys(this.props.regions_provinces) ?? [],
            filtered_provinces: [...new Set(Object.values(this.props.regions_provinces).flat())],
          },
          async () => {
            await this.fetchDealers()
            this.setState({ ready: true })
            let { filtered_brands, filtered_users, status_filter, filtered_regions, filtered_provinces } = this.state
            filtered_brands.sort()
            filtered_users.sort()
            filtered_regions.sort()
            filtered_provinces.sort()
            this.initialFiltersHash = hash({
              filtered_brands: filtered_brands,
              filtered_users: filtered_users,
              status_filter: status_filter,
              filtered_regions: filtered_regions,
              filtered_provinces: filtered_provinces,
            })
            this.updateFiltersHash()
          }
        )
      }
    )
  }

  componentDidUpdate(prevProps, prevState) {
    const { ready, filtered_brands, filtered_users, status_filter, filtered_regions, filtered_provinces } = this.state
    if (
      ready === true &&
      (prevState.filtered_brands !== filtered_brands ||
        prevState.filtered_users !== filtered_users ||
        prevState.status_filter !== status_filter ||
        prevState.filtered_regions !== filtered_regions ||
        prevState.filtered_provinces !== filtered_provinces)
    ) {
      this.fetchDealers()
    }
  }

  updateFiltersHash = () => {
    let { filtered_brands, filtered_users, status_filter, filtered_regions, filtered_provinces } = this.state
    filtered_brands.sort()
    filtered_users.sort()
    filtered_regions.sort()
    filtered_provinces.sort()
    this.setState({
      filters_hash: hash({ filtered_brands, filtered_users, status_filter, filtered_regions, filtered_provinces }),
    })
  }

  fetchDealers = async () => {
    const { filtered_brands, filtered_users, status_filter, filtered_regions, filtered_provinces } = this.state
    this.setState({ loading: true })
    await this.props.dispatch(
      getAllDealers({
        status_filter,
        filtered_brands,
        filtered_users,
        filtered_regions,
        filtered_provinces,
        avoid_duplicates: true,
      })
    )
    this.setState({ loading: false, current_dealer: null })
  }

  onChangeFilter = name => values => {
    if (name === 'filtered_users') {
      values = values.map(user => user.id)
    }
    if (name === 'filtered_regions') {
      // Quando viene cambiato il filtro delle regioni, dobbiamo filtrare le province
      // in base alle regioni selezionate
      const filteredProvinces = values
        .map(region => this.props.regions_provinces[region]) // Ottieni le province per ciascuna regione
        .flat() // Appiattisci l'array in un unico array di province
        .filter((value, index, self) => self.indexOf(value) === index) // Rimuovi duplicati

      // Aggiorna lo stato con le province filtrate
      this.setState(
        {
          filtered_regions: values,
          filtered_provinces: filteredProvinces, // Aggiungi le province filtrate
        },
        this.updateFiltersHash
      )
    } else {
      // Altri filtri
      this.setState({ [name]: values }, this.updateFiltersHash)
    }
  }

  renderBrandCellHtml = dealer_brands => {
    const brandElements = dealer_brands.map(b => {
      let status = getDealerBrandStatus(startOfToday(), b)
      let dotColor =
        {
          engaged: '#4CAF50',
          not_engaged: '#FF5C5C',
          in_progress: '#FFA500',
        }[status] || '#FFA500'

      return (
        <div key={b.brand.id} style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span
            style={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: dotColor,
              display: 'inline-block',
            }}
          />
          <div>
            <strong>{b.brand.name}</strong>
          </div>
        </div>
      )
    })

    const container = <div>{brandElements}</div>
    return ReactDOMServer.renderToStaticMarkup(container)
  }

  renderMarkers = (map, dealers) => {
    if (!map) return

    const markerClusterGroup = L.markerClusterGroup()

    // Rimuovi i marker esistenti prima di aggiungerne di nuovi
    map.eachLayer(layer => {
      if (layer instanceof L.MarkerClusterGroup) {
        map.removeLayer(layer)
      }
    })

    dealers.forEach(dealer => {
      let markerIcon = icons.success // Default
      let popupClass = 'popup-success' // Default popup class

      const marker = L.marker([dealer.lat, dealer.lng], { icon: markerIcon }).bindPopup(
        `<div class="popup-content">

           <h5>${dealer.business_name} (${dealer.piva})</h5>
           <p>${dealer.address}</p>
        ${this.renderBrandCellHtml(dealer.dealer_brands)}
           <button class="btn btn-primary details-button" style="display: block; margin: 0 auto;">Dettagli</button>
         </div>`
      )

      marker.on('popupopen', () => {
        const popupContainer = marker.getPopup()._container
        popupContainer.classList.add(popupClass) // Aggiungi la classe personalizzata

        // Aggiungi un listener per il click sul bottone "Dettagli"
        const detailsButton = popupContainer.querySelector('.details-button')
        detailsButton.addEventListener('click', () => {
          this.setState({ show: true, current_dealer: dealer })
        })
      })

      markerClusterGroup.addLayer(marker)
    })

    map.addLayer(markerClusterGroup)
  }

  closeDealer = () => {
    this.setState({ show: false, current_dealer: null })
  }

  onResetFilters = () => {
    this.setState(
      {
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_users: this.props.users.map(u => u.id),
        status_filter: 'all',
        filtered_regions: Object.keys(this.props.regions_provinces) ?? [],
        filtered_provinces: [...new Set(Object.values(this.props.regions_provinces).flat())],
      },
      () => {
        this.updateFiltersHash()
      }
    )
  }

  render() {
    const {
      filtered_brands,
      filtered_users,
      status_filter,
      loading,
      current_dealer,
      filtered_regions,
      filtered_provinces,
      filters_hash,
    } = this.state
    const { brands, users, user_id, dealers, regions_provinces } = this.props
    let regions = Object.keys(regions_provinces).map(k => ({ id: k, name: k }))
    let provinces = Object.keys(regions_provinces)
      .filter(k => filtered_regions.includes(k))
      .flatMap(
        region => regions_provinces[region].map(province => ({ id: province, name: province })) // Mappa le province in oggetti
      )

    return (
      <div className="card card-body container-fluid flex-fill d-flex flex-column px-0 pb-0 py-0 mb-0">
        <div className="d-flex flex-column flex-fill">
          <div
            className="toolbar px-2 flex-wrap"
            style={{ position: 'absolute', zIndex: 999, left: '5rem', top: '2rem' }}>
            <FilterGroup className="toolbar-item" showResetFilters={false}>
              <CheckboxFilter
                label="Brand"
                items={brands}
                filteredItems={filtered_brands}
                onChangeFilter={this.onChangeFilter('filtered_brands')}
                showSearch={true}
              />

              <RadiolistFilter
                label={'Stato'}
                items={this.dealer_statuses}
                value={status_filter}
                onChangeFilter={this.onChangeFilter('status_filter')}
                disabled={this.props.show_form}
              />
              {users.length > 0 && users[0].id !== user_id && (
                <Button
                  className="dropdown-toggle btn btn-primary"
                  onClick={() =>
                    this.selectAgentsModalRef.current.show({
                      selected_users: filtered_users,
                    })
                  }>
                  <Trans i18nKey="filter_agents">Funzionari</Trans>
                </Button>
              )}
            </FilterGroup>
            <FilterGroup
              className="toolbar-item"
              showResetFilters={this.initialFiltersHash !== filters_hash}
              onResetFilters={this.onResetFilters}>
              <CheckboxFilter
                label="Regioni"
                items={regions}
                filteredItems={filtered_regions}
                onChangeFilter={this.onChangeFilter('filtered_regions')}
                showSearch={true}
              />
              <CheckboxFilter
                label="Province"
                items={provinces}
                filteredItems={filtered_provinces}
                onChangeFilter={this.onChangeFilter('filtered_provinces')}
                showSearch={true}
              />
            </FilterGroup>
          </div>

          {loading && (
            <div className="loading-overlay">
              <Spinner animation="border" role="status" />
              <span>Loading...</span>
            </div>
          )}
          {this.state.ready && (
            <MapContainer
              center={[42, 12]}
              zoom={6}
              minZoom={6}
              style={{ height: '80vh', width: '100%' }}
              scrollWheelZoom={true}
              doubleClickZoom={false}
              dragging={true}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

              <MapUpdater onMapReady={this.renderMarkers} dealers={dealers} />
            </MapContainer>
          )}
        </div>

        <SelectAgentsModal
          ref={this.selectAgentsModalRef}
          users={users}
          brands={brands}
          selected_user={filtered_users}
          onChange={this.onChangeFilter('filtered_users')}
          multiSelection={true}
        />

        <Modal backdrop="static" centered show={this.state.show} onHide={this.closeDealer} size="xl">
          <Modal.Header>
            <Modal.Title>
              {current_dealer?.business_name ?? ''} ({current_dealer?.piva ?? ''})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex flex-column">
            <DealerForm
              dealer={current_dealer}
              brands={this.props.brands}
              agents={this.props.agents}
              categories={this.props.categories}
              business_role_priority={this.props.business_role_priority}
              onSave={this.saveDealer}
              closeForm={this.closeDealer}
              forceUseModal={true}
              readonly={true}
            />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

// Componente per gestire l'aggiornamento della mappa
const MapUpdater = ({ onMapReady, dealers }) => {
  const map = useMap()
  React.useEffect(() => {
    if (map) {
      onMapReady(map, dealers)
    }
  }, [map, dealers])

  return null
}

export default connect(mstp)(InteractiveMapDealers)
